// Built-in starter email templates.
// These are hardcoded on the frontend — no DB entry needed.
// User-saved templates come from the API and are merged in at display time.

export const BUILTIN_TEMPLATES = [
  {
    _id: 'builtin_header_cta',
    name: 'Header + Body + CTA',
    description: 'Logo banner, intro text, and a prominent call-to-action button.',
    category: 'header_cta',
    is_builtin: true,
    html_body: `<div style="max-width:600px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;color:#233044;background:#ffffff;">
  <!-- Header -->
  <div style="background:#8B63F6;padding:28px 32px;text-align:center;">
    <p style="margin:0;font-size:22px;font-weight:700;color:#ffffff;letter-spacing:-0.5px;">Your Company Name</p>
  </div>

  <!-- Hero image -->
  <div style="background:#F1F4F8;text-align:center;padding:0;">
    <img src="https://placehold.co/600x220/EEF2FF/8B63F6?text=Your+Image+Here" alt="Hero Image" width="600" style="display:block;width:100%;max-width:600px;" />
  </div>

  <!-- Body -->
  <div style="padding:40px 40px 32px;">
    <h1 style="font-size:26px;font-weight:700;color:#233044;margin:0 0 16px;line-height:1.3;">Your headline goes here</h1>
    <p style="font-size:15px;line-height:1.7;color:#617597;margin:0 0 16px;">Hi {{first_name}},</p>
    <p style="font-size:15px;line-height:1.7;color:#617597;margin:0 0 24px;">Replace this paragraph with your main message. Keep it concise and focused on what matters to your reader. One clear idea per paragraph works best.</p>
    <p style="font-size:15px;line-height:1.7;color:#617597;margin:0 0 32px;">Add a second paragraph here if needed — context, a brief story, or supporting detail that leads naturally into your call to action.</p>

    <!-- CTA Button -->
    <div style="text-align:center;margin:8px 0 8px;">
      <a href="https://yourlink.com" style="display:inline-block;background:#FF7B6E;color:#ffffff;padding:14px 36px;border-radius:8px;text-decoration:none;font-weight:700;font-size:16px;letter-spacing:0.2px;">Click Here to Get Started</a>
    </div>
  </div>

  <!-- Footer -->
  <div style="background:#F8FAFC;border-top:1px solid #E2E8F0;padding:24px 40px;text-align:center;">
    <p style="font-size:12px;color:#94A3B8;margin:0 0 6px;">© 2025 Your Company · 123 Main Street, City, Province</p>
  </div>
</div>`,
  },

  {
    _id: 'builtin_newsletter',
    name: 'Newsletter',
    description: 'Multi-section newsletter with header, featured content blocks, and footer.',
    category: 'newsletter',
    is_builtin: true,
    html_body: `<div style="max-width:600px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;color:#233044;background:#ffffff;">
  <!-- Header -->
  <div style="background:#233044;padding:24px 32px;display:flex;align-items:center;justify-content:space-between;">
    <p style="margin:0;font-size:20px;font-weight:700;color:#ffffff;">Your Newsletter</p>
    <p style="margin:0;font-size:12px;color:#94A3B8;">Monthly Edition</p>
  </div>

  <!-- Intro -->
  <div style="padding:32px 40px 24px;border-bottom:1px solid #E2E8F0;">
    <p style="font-size:15px;line-height:1.7;color:#617597;margin:0;">Hi {{first_name}}, here's what's new this month. Replace this intro with a short personal note — it helps open rates when it feels genuine.</p>
  </div>

  <!-- Section 1 -->
  <div style="padding:32px 40px 24px;border-bottom:1px solid #E2E8F0;">
    <img src="https://placehold.co/520x200/EEF2FF/8B63F6?text=Section+1+Image" alt="Section Image" width="520" style="display:block;width:100%;border-radius:8px;margin-bottom:20px;" />
    <p style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#8B63F6;margin:0 0 8px;">Featured Story</p>
    <h2 style="font-size:20px;font-weight:700;color:#233044;margin:0 0 12px;line-height:1.3;">Your first story headline</h2>
    <p style="font-size:14px;line-height:1.7;color:#617597;margin:0 0 16px;">Summarise your first story or update in 2–3 sentences. What happened? Why does it matter to this reader?</p>
    <a href="https://yourlink.com" style="font-size:14px;font-weight:600;color:#8B63F6;text-decoration:none;">Read more →</a>
  </div>

  <!-- Section 2 (two columns) -->
  <div style="padding:32px 40px 24px;border-bottom:1px solid #E2E8F0;">
    <p style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#FF7B6E;margin:0 0 20px;">Quick Updates</p>
    <table width="100%" cellpadding="0" cellspacing="0" border="0">
      <tr>
        <td width="48%" valign="top" style="padding-right:16px;">
          <p style="font-size:14px;font-weight:700;color:#233044;margin:0 0 8px;">Update One</p>
          <p style="font-size:13px;line-height:1.6;color:#617597;margin:0;">Short description of this update or highlight. Keep it to 2 sentences.</p>
        </td>
        <td width="4%"></td>
        <td width="48%" valign="top">
          <p style="font-size:14px;font-weight:700;color:#233044;margin:0 0 8px;">Update Two</p>
          <p style="font-size:13px;line-height:1.6;color:#617597;margin:0;">Short description of this update or highlight. Keep it to 2 sentences.</p>
        </td>
      </tr>
    </table>
  </div>

  <!-- CTA -->
  <div style="padding:32px 40px;text-align:center;">
    <p style="font-size:16px;font-weight:600;color:#233044;margin:0 0 20px;">Ready to take the next step?</p>
    <a href="https://yourlink.com" style="display:inline-block;background:#233044;color:#ffffff;padding:13px 32px;border-radius:8px;text-decoration:none;font-weight:600;font-size:15px;">Book a Call</a>
  </div>

  <!-- Footer -->
  <div style="background:#F8FAFC;border-top:1px solid #E2E8F0;padding:24px 40px;text-align:center;">
    <p style="font-size:12px;color:#94A3B8;margin:0 0 6px;">© 2025 Your Company · 123 Main Street, City, Province</p>
  </div>
</div>`,
  },

  {
    _id: 'builtin_announcement',
    name: 'Announcement',
    description: 'Bold centred layout for product launches, events, or important news.',
    category: 'announcement',
    is_builtin: true,
    html_body: `<div style="max-width:600px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;color:#233044;background:#ffffff;">
  <!-- Header band -->
  <div style="background:linear-gradient(135deg,#8B63F6 0%,#FF7B6E 100%);padding:48px 40px;text-align:center;">
    <p style="margin:0 0 12px;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:2px;color:rgba(255,255,255,0.8);">Announcement</p>
    <h1 style="margin:0;font-size:32px;font-weight:700;color:#ffffff;line-height:1.2;">Something exciting<br/>is here</h1>
  </div>

  <!-- Body -->
  <div style="padding:40px 48px;text-align:center;">
    <p style="font-size:15px;line-height:1.7;color:#617597;margin:0 0 24px;">Hi {{first_name}}, replace this with your announcement. Get straight to the point — one powerful sentence about what you're announcing.</p>
    <p style="font-size:15px;line-height:1.7;color:#617597;margin:0 0 36px;">Add a brief supporting sentence explaining the benefit or the "so what" for your reader. Then invite them to act.</p>

    <a href="https://yourlink.com" style="display:inline-block;background:#8B63F6;color:#ffffff;padding:16px 40px;border-radius:10px;text-decoration:none;font-weight:700;font-size:17px;margin-bottom:16px;">Learn More</a>

    <p style="font-size:13px;color:#94A3B8;margin:20px 0 0;">Questions? Reply to this email — we'd love to hear from you.</p>
  </div>

  <!-- Image -->
  <div style="padding:0 40px 40px;">
    <img src="https://placehold.co/520x240/EEF2FF/8B63F6?text=Your+Image+Here" alt="Announcement Image" width="520" style="display:block;width:100%;border-radius:12px;" />
  </div>

  <!-- Footer -->
  <div style="background:#F8FAFC;border-top:1px solid #E2E8F0;padding:24px 40px;text-align:center;">
    <p style="font-size:12px;color:#94A3B8;margin:0 0 6px;">© 2025 Your Company · 123 Main Street, City, Province</p>
  </div>
</div>`,
  },

  {
    _id: 'builtin_followup',
    name: 'Follow-up / Plain Text',
    description: 'Clean, minimal layout that reads like a personal email. Great for follow-ups.',
    category: 'followup',
    is_builtin: true,
    html_body: `<div style="max-width:560px;margin:0 auto;font-family:Georgia,serif;color:#233044;background:#ffffff;padding:40px 0;">
  <p style="font-size:15px;line-height:1.8;color:#233044;margin:0 0 20px;">Hi {{first_name}},</p>

  <p style="font-size:15px;line-height:1.8;color:#233044;margin:0 0 20px;">I wanted to follow up on my last message about [topic]. Replace this with the context of your follow-up — keep it brief and direct.</p>

  <p style="font-size:15px;line-height:1.8;color:#233044;margin:0 0 20px;">I think there could be a real opportunity here for <strong>{{company}}</strong>, and I'd love to show you how we've helped similar companies [specific result].</p>

  <p style="font-size:15px;line-height:1.8;color:#233044;margin:0 0 20px;">Would you be open to a quick 15-minute call this week? You can book directly here: <a href="https://yourlink.com" style="color:#8B63F6;text-decoration:none;font-weight:600;">Pick a time →</a></p>

  <p style="font-size:15px;line-height:1.8;color:#233044;margin:0 0 32px;">Either way, happy to answer any questions by email if that's easier.</p>

  <p style="font-size:15px;line-height:1.8;color:#233044;margin:0 0 4px;">Best,</p>
  <p style="font-size:15px;line-height:1.8;color:#233044;margin:0 0 40px;font-weight:600;">{{assigned_to_name}}</p>

  <div style="border-top:1px solid #E2E8F0;padding-top:20px;">
    <p style="font-size:11px;color:#94A3B8;margin:0;">Your Company · your@email.com · (555) 000-0000</p>
  </div>
</div>`,
  },
];

export const CATEGORY_LABELS = {
  header_cta:   'Header + CTA',
  newsletter:   'Newsletter',
  announcement: 'Announcement',
  followup:     'Follow-up',
  custom:       'Custom',
};
